import { createContext } from "react";

export interface CreateWorkspaceLoaderContextType {
  startLoading: () => { cancel: () => void; setCanFinish: () => void };
  cancel: () => void;
  canFinishLoading: boolean;
  isLoading: boolean;
}

export const CreateWorkspaceLoaderContext =
  createContext<CreateWorkspaceLoaderContextType | null>(null);
